import en from './en.ts'
import ru from './ru.ts'
import uk from './uk.ts'

export default { en, ru, uk }
